// Implementaciones manuales para reemplazar librerías obsoletas

// Reemplazo de lodash.orderby
export const orderBy = (array, iteratees, orders) => {
  if (!Array.isArray(array)) return [];
  
  const sortedArray = [...array];
  
  return sortedArray.sort((a, b) => {
    for (let i = 0; i < iteratees.length; i++) {
      const iteratee = iteratees[i];
      const order = orders && orders[i] === 'desc' ? -1 : 1;
      
      let aValue = a;
      let bValue = b;
      
      if (typeof iteratee === 'string') {
        aValue = get(a, iteratee);
        bValue = get(b, iteratee);
      } else if (typeof iteratee === 'function') {
        aValue = iteratee(a);
        bValue = iteratee(b);
      }
      
      if (aValue < bValue) return -1 * order;
      if (aValue > bValue) return 1 * order;
    }
    return 0;
  });
};

// Reemplazo de lodash.get
export const get = (obj, path, defaultValue) => {
  const keys = Array.isArray(path) ? path : path.split('.');
  let result = obj;
  
  for (const key of keys) {
    if (result == null || typeof result !== 'object') {
      return defaultValue;
    }
    result = result[key];
  }
  
  return result !== undefined ? result : defaultValue;
};

// Reemplazo de lodash.set
export const set = (obj, path, value) => {
  const keys = Array.isArray(path) ? path : path.split('.');
  let current = obj;
  
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!(key in current) || typeof current[key] !== 'object') {
      current[key] = {};
    }
    current = current[key];
  }
  
  current[keys[keys.length - 1]] = value;
  return obj;
};

// Reemplazo de lodash.memoize
export const memoize = (func, resolver) => {
  const cache = new Map();
  
  return function(...args) {
    const key = resolver ? resolver(...args) : JSON.stringify(args);
    
    if (cache.has(key)) {
      return cache.get(key);
    }
    
    const result = func.apply(this, args);
    cache.set(key, result);
    return result;
  };
};

// Reemplazo de lodash.debounce
export const debounce = (func, wait, immediate = false) => {
  let timeout;
  
  const debounced = function executedFunction(...args) {
    const later = () => {
      timeout = null;
      if (!immediate) func(...args);
    };
    
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    
    if (callNow) func(...args);
  };

  // Add cancel method to match lodash debounce API
  debounced.cancel = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Reemplazo de jwt-decode
export const jwtDecode = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    throw new Error('Invalid token');
  }
};
